import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class OrganizeService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  list(query?: any) {
    return this.get('/v2/organizes', query);
  }

  create(body: any) {
    return this.post('/v2/organize', body);
  }

  find(id) {
    return this.get('/v2/organize/' + id);
  }

  update(id, body) {
    return this.put('/v2/organize/' + id, body);
  }

  _delete(id) {
    return this.delete('/v2/organize/' + id);
  }

  allOrganize(query?: any) {
    return this.get('/v2/all-organize', query);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/Organize.service.ts